import { NavLink } from 'react-router-dom';
import { FolderHeart, Home, LayoutDashboard, Users, UserRound } from 'lucide-react';
import { cn } from '@/lib/utils';
import { fa } from '@/i18n/fa';
import { ThemeToggle } from '@/components/shared/ThemeToggle';

const navItems = [
  { to: '/', label: fa.nav.home, icon: Home },
  { to: '/members', label: fa.nav.members, icon: Users },
  { to: '/archive', label: fa.nav.archive, icon: FolderHeart },
  { to: '/reports', label: fa.nav.reports, icon: LayoutDashboard },
  { to: '/profile', label: fa.nav.profile, icon: UserRound },
] as const;

/** Responsive top nav shown on wider screens (sm and up); replaces the bottom tab bar. */
export function Header() {
  return (
    <header className="sticky top-0 z-30 hidden border-b border-border bg-surface/90 backdrop-blur-md sm:block">
      <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-6">
        <div className="flex items-center gap-2">
          <span className="flex size-8 items-center justify-center rounded-control bg-primary-600 text-sm font-bold text-white">
            ص
          </span>
          <span className="text-base font-bold text-text">{fa.app.name}</span>
        </div>

        <div className="flex items-center gap-3">
          <ul className="flex items-center gap-1">
            {navItems.map(({ to, label, icon: Icon }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  end={to === '/'}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-2 rounded-control px-3 py-2 text-sm font-medium text-text-muted transition-colors hover:bg-primary-50 hover:text-primary-700',
                      isActive && 'bg-primary-50 text-primary-700',
                    )
                  }
                >
                  <Icon className="size-4" />
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
